module.exports = __webpack_public_path__ + "img/10-10-1.6d5080b1.jpg";